<ng-container *ngFor="let statusAction of statusFlowActions">
	<ng-template
		[ngTemplateOutlet]="enforceCustomTemplate ? actionItemTplRef : actionItemTpl"
		[ngTemplateOutletContext]="{
			actionItemTpl: actionItemTpl,
			action: statusAction?.actionItem?.action,
			statusAction: statusAction
		}"
	></ng-template>
</ng-container>

<!-- ######################### TEMPLATES ######################### -->
<ng-template
	#actionItemTpl
	let-statusAction="statusAction"
	let-isDisabled="hostConditionallyIsDisabled"
	let-isHidden="hostConditionallyIsHidden"
	let-isRendered="hostConditionallyIsRendered"
	let-messages="hostConditionallyMessages"
	let-showLoader="hostConditionallyShowLoader"
	let-svgFillable="actionItemSvgFillable"
>
	<app-action-item
		*ngIf="statusAction?.isRendered && isRendered ?? true"
		[ngClass]="{
			'd-none': statusAction?.isHidden || isHidden
		}"
		[actionIconSize]="actionIconSize"
		[actionIconType]="actionIconTypeEnum.SVG"
		[svgFillable]="svgFillable ?? false"
		[actionItem]="statusAction?.actionItem?.actionItemIcon ?? statusAction?.actionItem?.action"
		[disabled]="statusAction?.isDisabled || isDisabled"
		[displayMode]="displayMode"
		[label]="
			statusAction?.actionItem?.labelI18n
			? getI18nString( false, statusAction?.actionItem?.labelI18n )
			: null
		"
		[scopes]="statusAction.actionItem.scopes"
		[showLoader]="statusAction.showLoader || showLoader"
		[tooltip]="
			showTooltip && statusAction?.actionItem?.tooltipI18n
			? getI18nString( false, statusAction?.actionItem?.tooltipI18n )
			: null
		"
		[tooltipHtml]="messages?.show ? tooltipHTML : null"
		(clickEvent)="changeStatus(statusAction)"
	></app-action-item>

	<ng-template #tooltipHTML>
		<app-entity-messages [messages]="messages"></app-entity-messages>
	</ng-template>
</ng-template>
